<template>
	<Head title="Erro" />
	<h4 class="text-center text-danger" id="error">{{ message }}</h4>
	<h4 class="text-center text-danger" id="error" v-if="link">
		<a :href="link">{{ link_text }}</a>
	</h4>
</template>

<script lang="ts">
	import Layout from '../../Layouts/simple_layout.vue';
	import { Head } from '@inertiajs/vue3';

	export default {
		layout: Layout,
		components: {
			Head,
		},
		props: {
			message: { type: String, required: true },
			link: { type: String, required: false },
			link_text: { type: String, required: false },
		},
	};
</script>
